module.exports = __webpack_public_path__ + "assets/images/record_bg-0a2bae7ea0b1cef8a6edb1db616c7120.jpg";